import * as api from "@/api/williams/report";
import { PrintDialog } from "../dialogs";
import { TestEvent } from "@/api/williams/testEvents";
import { TestEventPrintOptions } from "@/api/williams/report";
import { useModalDialog } from "@/hooks";

export function usePrintTestEvent() {
  const dialog = useModalDialog();

  function showDialog(event: TestEvent) {
    dialog.show(PrintDialog, {
      onAccept: (options: TestEventPrintOptions) => api.printTestEvent(event, options),
    });
  }

  return { showDialog };
}
